import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toast-item',
  templateUrl: './toast-item.component.html',
  styleUrls: ['./toast-item.component.scss'],
})
export class ToastItemComponent implements OnInit {
  @Output()
  onTimePassed = new EventEmitter();

  @Input()
  toast: any;

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.onTimePassed.emit(this.toast);
    }, 7000);
  }
}
